import { pageProblemText } from "@/lib/tina/festival-page";

interface ProblemsListProps {
  problems: string[];
  /** A Mood event id as a curator reads it. */
  nameOf: (moodEventId: string) => string;
}

/** One sentence per problem; nothing when there is none. */
export function ProblemsList({ problems, nameOf }: ProblemsListProps) {
  if (problems.length === 0) return null;
  return (
    <ul
      className="list-disc rounded-md border border-red-300 bg-red-50 p-3 pl-8 text-sm text-red-800 dark:bg-red-950/30 dark:text-red-300"
      aria-label="Problems"
    >
      {problems.map((problem) => (
        <li key={problem}>{pageProblemText(problem, nameOf)}</li>
      ))}
    </ul>
  );
}
